import * as Yup from "yup";

const useSublimationClothConfig = () => {
  const validationSchema = Yup.object({  
    cloth_name: Yup.string().required('Cloth type name is required'),
    imgpath: Yup.mixed().required('Image is required'), 
  });

  const initialValues = {
    id:0,    
    cloth_name: '',
    imgpath: null,
  };

  return { validationSchema, initialValues };
};

export default useSublimationClothConfig;
